import { NotificationType } from '@lib/store';
import { TextColorsEnum } from '@shared/widgets';
import LogoLight from '@assets/icons/logo/logo-name-big.svg';
import LogoDark from '@assets/icons/logo/logo-name-big-dark.svg';
import LogoLightSmall from '@assets/icons/logo/logo-small.svg';
import LogoDarkSmall from '@assets/icons/logo/logo-small-dark.svg';
import LogoVcfcSmall from '@assets/icons/logo/logo-vcfc-small.svg';
import LogoVcfc from '@assets/icons/logo/logo-vcfc.svg';

export const Palette = {
  Insignia: 'insignia',
  VCFC: 'vcfc',
  Personal: 'personal',
  Default: '',
} as const;
export type Palette = (typeof Palette)[keyof typeof Palette];

const COLOR_PALETTE = process.env.COLOR_PALETTE?.toLowerCase();

export class PaletteUtils {
  static isInsigniaPalette = !COLOR_PALETTE || COLOR_PALETTE === Palette.Default || COLOR_PALETTE === Palette.Insignia;
  static isVcfcPalette = COLOR_PALETTE === Palette.VCFC || COLOR_PALETTE === Palette.Personal;
  static isPersonalPalette = COLOR_PALETTE === Palette.Personal;

  static spendingByCurrencyInsigniaColors = ['#d7c29a', '#322ea9'];
  static spendingByCurrencyVcfcColors = ['#374A61', '#d3c39f1a', '#d3c39f00'];
  static expenseCategoriesVcfcColors = ['#374A61', '#545E4D', '#CAB8A3', '#A6A6A6', '#6A8794', '#A9C8D9'];
  static mostUsedMerchantsVcfcColors = ['#374A61', '#545E4D', '#CAB8A3', '#A6A6A6', '#A9C8D9'];
  static spendingByCurrencyPersonalColors = ['#48191A', '#E6D6D2', '#00000000'];
  static expenseCategoriesPersonalColors = ['#48191A', '#6B2E2F', '#9C6A63', '#C8B2AC', '#7A8A92', '#AFC3CC'];
  static mostUsedMerchantsPersonalColors = ['#48191A', '#6B2E2F', '#9C6A63', '#AFC3CC', '#D9E1E5'];

  static getColor = <T, U>(insigniaColor: T, vcfcColor?: U) => {
    if (this.isInsigniaPalette) return insigniaColor;
    if (this.isVcfcPalette) return vcfcColor;
    return;
  };

  static getNotificationColor = (type: NotificationType) => {
    switch (type) {
      case NotificationType.Error:
        return TextColorsEnum.Red;
      case NotificationType.Warning:
        return TextColorsEnum.Primary;
      case NotificationType.Success:
        return TextColorsEnum.Green;
      default:
        return;
    }
  };

  static getLogo = (isDark: boolean, isCollapsed: boolean) => {
    if (this.isInsigniaPalette) {
      if (!isDark) return isCollapsed ? <LogoLightSmall /> : <LogoLight />;
      else return isCollapsed ? <LogoDarkSmall /> : <LogoDark />;
    }
    if (this.isVcfcPalette) return isCollapsed ? <LogoVcfcSmall /> : <LogoVcfc />;
    return null;
  };
}
